export { default as Tabs } from "./Tabs";
export type {
  TabsProps,
  TabProps,
  TabListProps,
  TabPanelProps,
  TabPanelsProps,
} from "./Tabs.types";
